<app-bandeau-avis></app-bandeau-avis>
<app-accueil-pes *ngIf="!estIntranet"></app-accueil-pes>
<div class="container">
    <app-accueil-intranet *ngIf="estIntranet"></app-accueil-intranet>
</div>